import { SVGProps } from 'react'

export const VueIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <path
      d="m24.742 4-4.267 7.39L16.208 4H2l18.475 32L38.95 4H24.742Z"
      fill="#41B883"
    />
    <path
      d="m24.741 4-4.266 7.39L16.208 4H9.39l11.085 19.2L31.56 4H24.74Z"
      fill="#34495E"
    />
  </svg>
)
